__turbopack_context__.v({
  "code-block": "code-block-module__J8JhyG__code-block",
  "content": "code-block-module__J8JhyG__content",
  "line": "code-block-module__J8JhyG__line",
  "line_indicator": "code-block-module__J8JhyG__line_indicator",
  "pre": "code-block-module__J8JhyG__pre",
});
